/*
 * @Date: 2020-03-24 09:56:51
 * @LastEditors: chentianyang
 * @LastEditTime: 2021-08-05 12:19:23
 * @FilePath: \st-teacher-2020\src\store\modules\user.ts
 */
/**
 * @file user模块
 * @author windwithfo(windwithfo@yeah.net)
 */
import S from '@/service';
// import { State } from 'vuex-class';

function isSomeRole(role: string, roles: string[]): boolean {
  return roles && roles.indexOf(role) !== -1;
}

interface StateClass {
  userInfo: any;
  accountStatus: number;
  floatingWindow: any;
  noviceDialog: any;
  remoteLoginCount: number;
}

enum OptionsType {
  FLOATINGWINDOW,
  GUIDE,
  NOVICE
}

const userInfo = {
  namespaced: true,
  state: {
    userInfo: {},
    accountStatus: 0,
    floatingWindow: null,
    noviceDialog: null,
    remoteLoginCount: 0,
  },
  getters: {
    authenticated: (state: StateClass) => state.userInfo.userId != null,
    userInfo: (state: StateClass) => state.userInfo,

    getAccountStatus(state: StateClass) {
      // 1:即将过期,2过期
      return state.accountStatus;
    },
    // 是否为普通管理员
    isManage(state: StateClass) {
      const { roles } = state.userInfo;
      return isSomeRole('manage', roles);
    },
    // 是否为超级管理员
    isSuperManage(state: StateClass) {
      const { roles } = state.userInfo;
      return isSomeRole('super_manager', roles);
    },
    // 是否为老师
    isTeacher(state: StateClass) {
      const { roles } = state.userInfo;
      return isSomeRole('teacher', roles);
    },
    // 是否为助教
    isDt(state: StateClass) {
      const { roles } = state.userInfo;
      return isSomeRole('dt_assistant', roles);
    },
    // 是否是北校机构
    isGaosi(state: StateClass) {
      const { institutionId } = state.userInfo;
      // 24代表北校机构
      return institutionId === 24;
    },
    // 是否为双师主讲老师
    isDoubleTeacher(state: StateClass) {
      const { doubleTeacherStatus } = state.userInfo;
      return doubleTeacherStatus === 2;
    },
    // 获取用户权限
    getPageAccess(state: StateClass) {
      const { pageAccess } = state.userInfo;
      return pageAccess;
    },
    // 获取新手引导数据
    getGuideOptions(state: StateClass) {
      const { guideOptions } = state.userInfo;
      return guideOptions;
    },
    // 获取浮窗数据
    getFloatingWindow(state: StateClass) {
      return state.floatingWindow;
    },
    // 获取上线公告数据
    getNoviceDialog(state: StateClass) {
      return state.noviceDialog;
    },
    // 获取异地登录次数
    getRemoteLoginCount(state: StateClass) {
      return state.remoteLoginCount;
    },
  },
  mutations: {
    // 更新用户state数据
    async updateUserInfo(state: StateClass, data: any) {
      state.userInfo = { ...state.userInfo, ...data };
    },
    // 更新账号状态
    upateAccountStatus(state: StateClass, data: any) {
      state.accountStatus = data;
    },
    // 更新新手引导状态
    updateGuideOptions(state: StateClass, data: any) {
      state.userInfo.guideOptions = data;
    },
    updateFloatingWindow(state: StateClass, data: any) {
      state.floatingWindow = data;
    },
    updateNoviceDialog(state: StateClass, data: any) {
      state.noviceDialog = data;
    },
    // 更新异地登录次数
    updateRemoteLoginCount(state: StateClass, data: any) {
      state.remoteLoginCount = data;
    },
  },
  actions: {
    // 加载用户信息
    fetchUserInfo() {
      return S.bk.getMenu();
    },
    // 获取用户权限
    getPageAccess() {
      return S.bk.getPageAccess();
    },
    // 获取用户班级数量
    getClassNum() {
      return S.bk.getClassNum();
    },
    // 获取弹框类数据
    async getGuideOption({ commit }: any) {
      const params = {
        businessLine: 'bsk',
      };
      const result = await S.common.getOption(params);
      const guideOptions = {};
      (result as any).forEach((item: any) => {
        if (item.type === OptionsType.GUIDE) {
          item.isOption = 0;
          Object.assign(guideOptions, {
            [item.code]: item,
          });
        } else if (item.type === OptionsType.FLOATINGWINDOW) {
          commit('updateFloatingWindow', item);
        } else if (item.type === OptionsType.NOVICE) {
          commit('updateNoviceDialog', item);
        }
      });
      return guideOptions;
    },
    // 更新新手引导操作
    saveOption({ commit, getters }: any, code: string) {
      const guideObject = getters.getGuideOptions[code];

      S.common.saveOption({ id: guideObject.id })
        .then(() => {
          const guideObjectTemp = JSON.parse(JSON.stringify(guideObject));
          guideObjectTemp.isOption = 1;
          const guideOptionsTemp = { ...getters.getGuideOptions, [code]: guideObjectTemp };
          commit('updateGuideOptions', guideOptionsTemp);
        });
    },
  },
};

export default userInfo;
